module.exports = __webpack_public_path__ + "img/fieldGoalPerformance.10624489.svg";